<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0">
                    <date-picker
                        v-model="search.date"
                        :format="changeFormat"
                        :lang="lang"
                        range
                        confirm
                        placeholder="วันที่เริ่มต้น - วันที่สิ้นสุด">
                    </date-picker>&nbsp;&nbsp;
                    <input type="text" class="form-control" v-model="search.re_number" placeholder="ค้นหาเลข RE">
                    &nbsp;
                    <multiselect
                        v-model="search.customer"
                        class="form-control border-0"
                        :options="optionCustomer"
                        :customLabel="customerWithLabel"
                        placeholder="ค้นหาลูกค้า"
                        :show-labels="false"
                        track-by="id">
                    </multiselect>
                    &nbsp;
                    <button class="btn btn-success my-2 my-sm-0"
                            @click="searchBillingRE(1)"
                            type="button">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>
                    &nbsp;
                    <button :disabled="checkbox_id.length < 1" @click="multiPrint"
                            class="btn btn-warning"
                            type="button">
                        <icon name="print"></icon>
                        พิมพ์หลายใบ
                    </button>
                </form>
            </div>
        </nav>
        <div class="table-responsive">
            <table class="table table-bordered">
                <thead>
                <tr>
                    <th>
                        <input type="checkbox" v-if="search.customer" v-model="selectAll"/>
                    </th>
                    <th>ลำดับ</th>
                    <th>เลขที่ใบเสร็จ</th>
                    <th>วันที่</th>
                    <th>พนักงานขาย</th>
                    <th>ลูกค้า</th>
                    <th>พิมพ์</th>
                    <th>ดูข้อมูล</th>
                    <th>ลบ</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(data,index) in tableList">
                    <td>
                        <input :value="data" type="checkbox"
                               v-model="checkbox_id"/>
                    </td>
                    <td>{{ ((dataPaginate.current_page - 1) * 10) + (index + 1) }}</td>
                    <td>
                        <template v-if="data.re_number">
                            {{ data.re_number }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.date">
                            {{ data.date | moment("DD/MM/YYYY") }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.sale">
                            {{ data.sale.sale_id }}{{ data.sale.name }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.customer">
                            {{ data.customer.store_name }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <button class="btn btn-primary" @click="printBillingRE(data.id)">
                            <icon name="print"></icon>
                            พิมพ์ใบเสร็จ
                        </button>
                    </td>
                    <td>
                        <button type="button" class="btn btn-info"
                                @click="showBillingRE(data.id)">
                            <icon name="pencil-alt"></icon>
                            ดูข้อมูล
                        </button>
                    </td>
                    <td>
                        <a @click="showDeleteModal(data.id)">
                            <icon name="trash"></icon>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div v-if="tableList.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getBillingREPage(dataPaginate.current_page)">
            </vue-pagination>
        </div>
        <b-modal hide-header hide-footer ref="delete_item">
            <delete-confirm-modal @submit="deleteRE">
            </delete-confirm-modal>
        </b-modal>
        <!--<pre class="alert-primary">{{tableList}}</pre>-->
    </div>
</template>

<script>
import {mapState} from "vuex";
import {domain} from "../../../util/Constants";
import moment from "moment";
import VuePagination from "../../Pagination";
import DatePicker from 'vue2-datepicker'
import Multiselect from "vue-multiselect";
import DeleteConfirmModal from "../../Utility/DeleteConfirmModal";

export default {
    components: {VuePagination, DatePicker, Multiselect, DeleteConfirmModal},
    name: "billing-re-list",
    created() {
        this.getBillingREPage(1);
        this.getCustomerAll();
    },
    data() {
        return {
            optionCustomer: [],
            page: 1,
            delete_id: null,
            search: {
                date: [],
                re_number: '',
                customer: null,
            },
            event_search: false,
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/' + year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
            checkbox_id: [],

        }
    },
    computed: {
        ...mapState({
            tableList: state => {
                return state.BillingRE.billings_re
            },
            dataPaginate: state => {
                return state.BillingRE.dataPaginate
            },
        }),
        selectAll: {
            get: function () {
                return this.taxInvoiceList ? this.checkbox_id.length >= this.taxInvoiceList.length : false;
            },
            set: function (value) {
                if (value) {
                    this.$store.dispatch("Billing/setSelectAll", true)
                    this.selectBillingAll();
                } else {
                    this.$store.dispatch("Billing/setSelectAll", false)
                    this.checkbox_id = [];
                }
            }
        },
    },
    methods: {
        multiPrint() {
            if (this.checkbox_id.length > 0) {
                let id = '';
                this.checkbox_id.forEach((x, i) => {
                    if (i > 0) id += ',' + x.id
                    else id += x.id
                })
                window.open(domain + "/receipt-pdf/" + id, '_blank');
            }
        },
        showDeleteModal(id) {
            //console.log(id);
            this.delete_id = id;
            this.$refs.delete_item.show();
        },
        hideDeleteModal() {
            this.$refs.delete_item.hide();
        },
        deleteRE(value) {
            if (value) {
                this.$store.dispatch("BillingRE/deleteBillingRE", this.delete_id).then(() => {
                    alert('ลบรายการสำเร็จ');
                    this.getBillingREPage(1);
                }).catch(() => {
                    alert('ลบรายการไม่สำเร็จ');
                })
            }
            this.hideDeleteModal();
        },
        getCustomerAll() {
            this.$store.dispatch("Customer/setAllCustomer").then(customers => {
                this.optionCustomer = customers;
            });
        },
        customerWithLabel(option) {
            return `${option.customer_id} - ${option.store_name}`
        },
        showBillingRE(id) {
            this.$store.dispatch("BillingRE/showBilling", id).then(() => {
                let route = this.$router.resolve("/accounting/billing-RE-form");
                window.open(route.href, '_blank');
                // this.goToBillingREForm();
            });
        },
        goToBillingREForm() {
            this.$router.push("/accounting/billing-RE-form");
        },
        printBillingRE(id) {
            window.open(domain + "/receipt-pdf/" + id, '_blank');
        },
        getBillingREPage(page) {
            this.page = page;
            if (this.event_search) {
                this.searchBillingRE(this.page);
            } else {
                this.$store.dispatch("BillingRE/getBillings", this.page);
            }
        },
        searchBillingRE(page) {
            this.event_search = true;
            let start_date = "";
            let end_date = "";
            if (this.search.date.length > 0 && this.search.date[0]) {
                start_date = moment(this.search.date[0]).format("YYYY-MM-DD");
                end_date = moment(this.search.date[1]).format("YYYY-MM-DD");
            } else {
                this.search.date = [];
            }
            let data = {
                page: page,
                start_date: start_date,
                end_date: end_date,
                re_number: this.search.re_number,
                customer_id: this.search.customer ? this.search.customer.id : '',
            };
            this.$store.dispatch("BillingRE/searchBillingRE", data);
        }
    }
}
</script>

<style scoped>

</style>
